import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=131e9d20&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=131e9d20&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e9d20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\site\\online-photo\\image-upscaler-spa\\aiseesoft.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131e9d20')) {
      api.createRecord('131e9d20', component.options)
    } else {
      api.reload('131e9d20', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=131e9d20&scoped=true", function () {
      api.rerender('131e9d20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgIcon/Index.vue"
export default component.exports